import React, {useState} from "react";
import Link from "next/link";

const Weddings: React.FC = ({ children }) => {
  const [themeValue, setthemeValue] = useState<number>(1)

  const toggleTheme = (x) => {
    if(x === 'up'){
      themeValue < 17 ? setthemeValue(themeValue + 1) : setthemeValue(1)
    } else {
      themeValue > 1 ? setthemeValue(themeValue - 1) : setthemeValue(17)
    }
  }

  return(
    <>
<section id="venue-hero">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>TacBoard for Parties</h1>
        <p>Seamless fun your party guests will love.</p>
        <Link href="/tacboard-pricing">
            <a className="get-tac-now">Get TacBoard Now</a>
        </Link>
      </div>
      <div className="bottom-wave"></div>
    </section>

<section className="events-description">
  <div className="content-container">
    <h2>Set up TacBoard at your party and create easy and fun entertainment for your guests all while building an amazing album of candid photos for everyone to enjoy browsing.</h2>
  </div>
</section>


    <section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Start the party off right<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
          <>
          {/* <source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" />

            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" /> */}

            <img src={`img/events-party-old.png`} alt="alt description" /></>
          </picture>
        </div>
        <div className="half">       
        <p>
        Have old photos already streaming on your TacBoard Live Stream when the party starts. 
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="includes">
      <h2 className="center">
        <span className="line"></span>Ask and You Shall Receive<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-corp-sign.png" alt="TacBoard Party Signs" />
          </picture>
          
        </div>
        <div className="half">      
        <p>
        Place some signs around at the event space asking guests to take selfies and text them to your TacBoard number. 
          </p>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Make Photo Fun<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-weddings-photo-area.png" alt="TacBoard Parties Photo Stage" />
          </picture>
        </div>
        <div className="half">
          <p>
          Make a photo station with fun props and a sign asking guests to snap some fun pics and text them to your TacBoard phone number.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

{/* <section className="includes" id="sign-shop bg-cream">
      <h2 className="center">
        <span className="line"></span>Have a Little Fun With It<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " />

            <img src="img/sign-shop-sign-selfie-station.jpg" alt="TacBoard Sign Shop" />
          </picture>
        </div>
        <div className="half">
          <p>
          Create a photo scavenger hunt for your guests to participate in.
          </p>
        </div>
      </div>
    </section> */}


    <section className="includes">
      <h2 className="center">
        <span className="line"></span>Everyone's Included<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-corp-remote.png" alt="TacBoard Party from anywhere" />
          </picture>
        </div>
        <div className="half">
          <p>
          Guests that can attend the party in person will be able to view your TacBoard Live Stream as well as send in their own photos from anywhere in the country. 
          </p>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Easy, Fun & Fabulous<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <video disableRemotePlayback className="thumb-vid" muted loop autoPlay preload="auto">
            <source src="img/av-live-screen.webm" type="video/webm" />
            <source src="img/av-live-screen.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="half">
          <p>
          Your guests will love it. It is fun, interactive and easy without being dominating, distracting, or obnoxious. 
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>


<section className="includes">
  <h2 className="center">
    <span className="line"></span>The Funs Not Over Yet<span className="line"></span>
  </h2>
  <div className="flex-container">
    <div className="half">
    <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/events-corp-gallery.png" alt="TacBoard Parties Photo Gallery" />
          </picture>
    </div>
    <div className="half">
      <p>
      You can seamlessly collect hundreds of photos from your event, all in one place for everyone to enjoy browsing after the event. 
      </p>
    </div>
  </div>
</section>

<section className="events-description">
  <div className="content-container">
    <h2>Sign up and get TacBoard for your your party!</h2>
  </div>
</section>

    </>
)}

export default Weddings;
